import React from 'react';
import { lineStatusWithImages } from '../../../utils/status';
import { components } from 'react-select';
import { makeStyles } from '@material-ui/core/styles';
import { noOverflow } from '../../../themes/styles';
import Status from '../../BuildingBlocks/Lines/Status';
import StyledSelect from '../../BuildingBlocks/Select/StyledSelect';

const useStyles = makeStyles((theme: any) => ({
  root: {
    backgroundColor: theme.palette.brand.white,
  },
  image: {
    position: 'absolute',
    left: theme.spacing(1),
  },
  customOptionText: {
    marginLeft: theme.spacing(2),
    display: 'inline-block',
    cursor: 'default',
    paddingLeft: theme.spacing(1),
    maxWidth: '100%',
    ...(noOverflow as object),
  },
}));

export default function FilterStatus({ onChange, lineOnEditMode }) {
  const classes = useStyles();

  const customOption = (props) => {
    const { data } = props;
    return (
      <div>
        <components.Option {...props}>
          <Status
            imgClassName={classes.image}
            textClassName={classes.customOptionText}
            status={data.value}
            filter={true}
          />
        </components.Option>
      </div>
    );
  };

  return (
    <StyledSelect
      className={classes.root}
      defaultValue={'All states'}
      CustomOption={customOption}
      onChange={(value) => {
        if (value.value === 'All states') onChange(null);
        else onChange(value.value);
      }}
      dropDownIconPath="icons/arrowMenuOpener.svg"
      options={lineStatusWithImages}
      disable={lineOnEditMode}
    />
  );
}
